import React from "react";

import { Button, Flex, FlexProps, Text } from "@chakra-ui/react";
import { useDownloadToCsv } from "am-tax-fe-core";

interface Props<T extends Record<string, unknown>> {
    children?: React.ReactNode | React.ReactNode[] | string | undefined;
    data: T[];
    fileName?: string;
    columnHeaders?: (string | null | undefined)[];
    debug?: boolean | undefined;
    label?: string | undefined;
}

const DownloadToCsvButton = <T extends Record<string, unknown>>(props: Props<T> & FlexProps) => {
    const { data, fileName, columnHeaders, children, justify = "inline-flex", debug, label, ...flexProps } = props;

    const downloadFn = useDownloadToCsv();

    const handleBtnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        if (debug) {
            console.log(JSON.stringify(data, null, 2));
        } else {
            downloadFn(data, fileName, columnHeaders);
        }
    };

    return (
        <Flex {...flexProps} justify={justify}>
            <Button variant="ghost" colorScheme="blue" onClick={handleBtnClick}>
                {children ? children : <Text>{label ?? "Download"}</Text>}
            </Button>
        </Flex>
    );
};

export default DownloadToCsvButton;
